/**
 * Sentry レポートを "しない" Error
 */
export class NoNeedReportError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'NoNeedReportError'
  }
}